import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  marker: {
    marginLeft: 8
  }
})
